import React, { useState } from 'react';
import ListItem from './ListItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

const ChipItems = [{ label: '전체' }, { label: '사업장' }, { label: '부서' }];

export default function NoticeList(props) {
  const [selectedChip, setSelectedChip] = useState('전체');

  const handleChipClick = (label) => {
    setSelectedChip(label);
  };

  // 공지 여부 체크된 시스템관리자가 올린 공지는 항상 보여져야 하므로 필터에서 제외
  const noticeItems =
    props?.rowData?.filter((item) => item.noticeYn === 'Y') || [];

  // noticeItems를 제외한 데이터
  const filteredItems =
    selectedChip === '전체'
      ? props?.rowData?.filter((item) => item.noticeYn !== 'Y')
      : props?.rowData?.filter(
          (item) => item.gubunNm === selectedChip && item.noticeYn !== 'Y'
        );

  const NoticeData = [...noticeItems, ...filteredItems];

  return (
    <div className="flex h-full flex-col">
      {/* Chip 필터 영역 - 고정 */}
      <div className="bg-background-light shrink-0 p-4">
        <div className="hide-scrollbar flex gap-2 overflow-x-auto">
          <Swiper slidesPerView="auto" spaceBetween={8}>
            {ChipItems.map((item, index) => (
              <SwiperSlide key={index} style={{ width: 'auto' }}>
                <button
                  onClick={() => handleChipClick(item.label)}
                  className={`rounded-full px-4 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors ${
                    selectedChip === item.label
                      ? 'bg-slate-800 text-white shadow-sm'
                      : ' border-slate-200 bg-white font-medium text-slate-600 '
                  }`}
                >
                  {item.label}
                </button>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* 공지 리스트 영역 - 스크롤 */}
      <div className="min-h-0 flex-1 overflow-auto">
        {NoticeData && NoticeData.length > 0 ? (
          <div className="space-y-3 px-4 pb-20">
            {NoticeData.map((item, index) => (
              <ListItem key={index} item={item} userInfo={props.userInfo} />
            ))}
          </div>
        ) : (
          <div className="flex h-full items-center justify-center p-3">
            <p className="text-slate-400">등록된 공지사항이 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
}
